// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3va8n","productName":"Table_productName__1TCvS"};